import request from '@/utils/request'

export function addFloor(data) {
  console.log('addFloorApi - 开始调用addFloor API')
  console.log('addFloorApi - 请求参数:', data)
  console.log('addFloorApi - 请求URL:', '/floor.saveFloor')
  console.log('addFloorApi - 请求方法:', 'post')
  
  return new Promise((resolve, reject) => {
    try {
      console.log('addFloorApi - 调用request方法')
      request({
        url: '/floor.saveFloor',
        method: 'post',
        data
      }).then(response => {
        console.log('addFloorApi - 请求成功，响应:', response)
        console.log('addFloorApi - 响应数据:', response.data)
        resolve(response.data)
      }).catch(error => {
        console.error('addFloorApi - 请求失败，错误:', error)
        reject(error)
      })
    } catch (error) {
      console.error('addFloorApi - 调用过程中发生异常:', error)
      reject(error)
    }
  })
}